import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-avoir-tab-content-negoce',
  templateUrl: './avoir-tab-content-negoce.component.html',
  styleUrls: ['./avoir-tab-content-negoce.component.scss']
})
export class AvoirTabContentNegoceComponent implements OnInit {
    status: string = 'Tous';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.status = this.route.snapshot.data['status'] || 'Tous';
    }
}
